module.exports = __webpack_public_path__ + "img/03.问天柏（杨树田-摄）.ee2354cc.jpg";